import * as React from 'react';

import { Route } from 'react-router';

import { PickupModeModal } from 'components/pickup-mode-modal';
import { Routes } from 'components/routes';
import { relativeRoutes } from 'utils/routing';

interface IPickUpRoutesProps {
  redirectUrl: string;
}

export const PickUpRoutes: React.FC<IPickUpRoutesProps> = ({ redirectUrl }) => {
  return (
    <Routes>
      {/* Used in global store card */}
      <Route
        path={relativeRoutes.pickupMode}
        element={<PickupModeModal redirectUrl={redirectUrl} />}
      />
    </Routes>
  );
};
